export default __webpack_public_path__ + "static/media/nptel_logo.14bc947a.png";